import { ReactNode } from "react";
import { IntegrationConfig, IntegrationType } from "@src/interfaces";
import { BaseIntegration } from "../BaseIntegration";
import { Lido } from "./Lido";

/**
 * Lido Integration - handles ETH staking operations
 * Allows users to buy ETH with cash and automatically stake it to get stETH
 */
export class LidoIntegration extends BaseIntegration {
  readonly type = IntegrationType.Lido;

  render(): ReactNode {
    return <Lido />;
  }

  getConfig(): IntegrationConfig {
    return {
      type: this.type,
      name: "Lido Staking",
      description:
        "Buy ETH with fiat and stake it directly to earn rewards, or unstake your stETH",
    };
  }
}
